import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useLanguage } from '@/i18n/LanguageContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading, isHydrated, authError } = useAuth();
  const { t } = useLanguage();
  const location = useLocation();

  // CRITICAL: Wait for auth hydration before making any redirect decision
  // This prevents false logouts during page loads, navigation, and publish flows
  if (loading || !isHydrated) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="text-center">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent mx-auto mb-4" />
          <p className="text-muted-foreground">{t.common.loading}</p>
        </div>
      </div>
    );
  }

  // If auth validation failed (stale token), redirect to login
  if (authError || !user) {
    console.log('[ProtectedRoute] No valid user after hydration, redirecting to login from:', location.pathname);
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
